import { render, staticRenderFns } from "./resourceEnterManageList.vue?vue&type=template&id=fa0beed6&scoped=true"
import script from "./resourceEnterManageList.vue?vue&type=script&lang=js"
export * from "./resourceEnterManageList.vue?vue&type=script&lang=js"
import style0 from "./resourceEnterManageList.vue?vue&type=style&index=0&id=fa0beed6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0beed6",
  null
  
)

export default component.exports